export default "__VITE_ASSET__DZp8u6hX__"